import '../immerBootstrap'
import { configureStore } from '@reduxjs/toolkit'
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk, { ThunkMiddleware } from 'redux-thunk'
import { Action } from './actions'
import reducers, { StoreState } from './reducers'

const persistConfig = {
    key: 'v-shops',
    storage: storage,
    whitelist: ['authUser', 'authAdmin', 'authSuperAdmin','cart','eventCart','appointmentCart','languages', 'favourites', 'translationLanguage','authDivision']
}

const persistedReducer = persistReducer(persistConfig, reducers)

const thunkMiddleware: ThunkMiddleware<StoreState, Action> = thunk

export const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => {
        const middlewares = getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            }
        })

        middlewares.push(thunkMiddleware)

        return middlewares
    },
    devTools: import.meta.env.DEV,
})

export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store)